<template>
  <div v-if="work && work.booking">
    <b-card key-nav style="background-color:orange" v-if="IsChanged()">
      <b-row>
        <b-col cols="1">
          <b-button @click="Save()">Spara</b-button>
        </b-col>
        <b-col cols="1">
          <b-button v-on:click="CancelChanges()">Avbryt</b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <label>Sändningsnummer:</label>
              <br />
              <h4>{{ work.booking.TspDocNo }}<clipboardbutton :value="work.booking.TspDocNo"></clipboardbutton>
              </h4>
              <!-- <div v-if="IsReadonly() && work && work.booking">
                <h3>{{ work.booking.TspDocNo }}</h3>
              </div>
              <b-form-input v-model="work.booking.TspDocNo" v-if="!IsReadonly()"></b-form-input> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>Datum:</label>
              <br />
              <datepicker v-model="work.booking.DeliveryDateText" :stepper="true" :readonly="IsReadonly()">
              </datepicker>
            </b-col>
            <b-col>
              <label>Tur:</label>
              <br />
              <b-form-input v-model="work.booking.TourName" v-bind:readonly="IsReadonly()"></b-form-input>
            </b-col>
            <b-col>
              <label>Terminal:</label>
              <br />
              <!-- <b-form-input v-model="work.booking.TerminalName" v-bind:readonly="IsReadonly()"></b-form-input> -->
              <!-- <b-form-select class="form-control" v-model="work.booking.TerminalId" :options="GetTerminals()" :readonly="IsReadonly()"></b-form-select> -->
              <lformselect class="form-control" v-model="work.booking.TerminalId" :options="GetTerminals()"
                :readonly="IsReadonly()"></lformselect>
            </b-col>
          </b-row>
        </b-col>
        <!-- BIG -->
        <b-col>
          <b-row>
            <b-col>
              <label>Ordertyp:</label>
              <br />
              <div v-if="IsReadonly()">
                {{ GetServiceTypeName(work.booking.ServiceTypeId) }}
              </div>
              <!-- <b-form-select class="form-control" v-model="work.booking.ServiceTypeId" :options="GetServiceTypes()" v-show="!IsReadonly()"></b-form-select> -->
              <lformselect class="form-control" v-model="work.booking.ServiceTypeId" :options="GetServiceTypes()"
                v-show="!IsReadonly()"></lformselect>
            </b-col>
            <b-col>
              <label>Status:</label>
              <br />
              {{ GetStatus(work.booking.StatusId) }}
            </b-col>
            <b-col>
              <div v-if="!work.booking.Locked && !work.pendingRelease">
                <b-icon-unlock-fill></b-icon-unlock-fill> Öppen
              </div>
              <div v-if="!work.booking.Locked && work.pendingRelease">
                <b-button variant="light"
                  :title="`Väntande frisläppning: ${work.pendingRelease.ContextKey}`"><b-icon-clock></b-icon-clock> {{
    GetPr(work)
  }}</b-button>
              </div>
              <div v-if="work.booking.Locked">
                <b-icon-lock-fill></b-icon-lock-fill> Låst
              </div>
              <b-button size="sm" v-if="work.booking.ConsolidationId && work.booking.ConsolidatedCount == 0">Ingår i
                konsolidering</b-button>
              <!-- <b-button size="sm" v-if="work.booking.ConsolidatedCount > 0">Huvudfrakt i konsolidering</b-button> -->
              <label v-if="work.booking.NoConsolidation">Ej konsolidering</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>Produkt:</label>
              <br />
              <!-- <b-form-select class="form-control" v-model="work.booking.ProductKey" :options="GetProducts()" :readonly="IsReadonly()"></b-form-select> -->
              <lformselect class="form-control" v-model="work.booking.ProductKey" :options="GetProducts()"
                :readonly="IsReadonly()"></lformselect>
              <!-- <b-form-input v-model="(work.product || { PrettyName: '' }).PrettyName"
                v-bind:readonly="IsReadonly() || true"></b-form-input> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col><label>Sla Min:</label>
              <datetimepicker v-model="work.booking.EtaMin" :editMode="!IsReadonly()"></datetimepicker>
            </b-col>
            <b-col><label>Sla Max:</label>
              <datetimepicker v-model="work.booking.Eta" :editMode="!IsReadonly()"></datetimepicker>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col>
          <label>Hämtadress:<b-icon-geo-alt
              @click="ShowOnMap(work.booking.PickupPlaceName, work.booking.PickupPlaceStreet, work.booking.PickupPlaceStreet2, work.booking.PickupPlacePostCode, work.booking.PickupPlaceCity)"
              title="Visa på karta"></b-icon-geo-alt></label>
          <b-button v-if="!IsReadonly()" size="sm" variant="outline-secondary" title="Adressregister"
            @click="selectPlace('Pickup')">Register</b-button>
          <br />
          <div>
            <b-row>
              <b-col>
                <b-form-input v-model="work.booking.PickupPlaceName" v-bind:readonly="IsReadonly()"
                  :formatter="formatter"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input v-model="work.booking.PickupPlaceStreet" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input v-model="work.booking.PickupPlaceStreet2" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-input v-model="work.booking.PickupPlacePostCode" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
              <b-col cols="8">
                <b-form-input v-model="work.booking.PickupPlaceCity" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col>
          <label>Leveransadress:<b-icon-geo-alt
              @click="ShowOnMap(work.booking.DeliveryPlaceName, work.booking.DeliveryPlaceStreet, work.booking.DeliveryPlaceStreet2, work.booking.DeliveryPlacePostCode, work.booking.DeliveryPlaceCity)"
              title="Visa på karta"></b-icon-geo-alt></label>
          <b-button v-if="!IsReadonly()" size="sm" variant="outline-secondary" title="Adressregister"
            @click="selectPlace('Delivery')">Register</b-button>
          <br />
          <div>
            <b-row>
              <b-col>
                <b-form-input v-model="work.booking.DeliveryPlaceName" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input v-model="work.booking.DeliveryPlaceStreet" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input v-model="work.booking.DeliveryPlaceStreet2" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-input v-model="work.booking.DeliveryPlacePostCode" v-bind:readonly="IsReadonly()">
                </b-form-input>
              </b-col>
              <b-col cols="8">
                <b-form-input v-model="work.booking.DeliveryPlaceCity" v-bind:readonly="IsReadonly()"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <label>Mobiltelefon:</label>
          <br />
          <b-form-input v-model="work.booking.PickupPhone" v-bind:readonly="IsReadonly()"></b-form-input>
        </b-col>
        <b-col cols="3">
          <label>Epost:</label>
          <br />
          <b-form-input v-model="work.booking.PickupEmail" v-bind:readonly="IsReadonly()"></b-form-input>
        </b-col>
        <b-col cols="3">
          <label>Mobiltelefon:</label>
          <br />
          <b-form-input v-model="work.booking.DeliveryPhone" v-bind:readonly="IsReadonly()"></b-form-input>
        </b-col>
        <b-col cols="3">
          <label>Epost:</label>
          <br />
          <b-form-input v-model="work.booking.DeliveryEmail" v-bind:readonly="IsReadonly()"></b-form-input>
        </b-col>
        <!-- <b-col cols="3">
          <label>Vikt (kg):</label>
          <br />
          <b-form-input type="number" v-model="work.booking.Weight" v-bind:readonly="IsReadonly()" ></b-form-input>
        </b-col>
        <b-col cols="3">
          <label>Volym (m3):</label>
          <br />
          <b-form-input type="number" step="0.001" min="0.00" max="99999.00" v-model="work.booking.Volume"
            v-bind:readonly="IsReadonly()"></b-form-input>
        </b-col> -->
      </b-row>
    </b-card>
    <b-card>

    </b-card>
    <b-card>
      <b-card-body>
        <label>Kommentar:</label>
        <br />
        <b-textarea v-model="work.booking.Comment" v-bind:readonly="IsReadonly()"></b-textarea>
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-header>
        <b-row>
          <b-col>
            Kollin <span v-if="work.collis">({{ work.collis.length }}st)</span>
            <b-icon-eye-fill @click="showCollis = true" v-if="!showCollis"></b-icon-eye-fill>
            <b-icon-eye-slash-fill @click="showCollis = false" v-if="showCollis"></b-icon-eye-slash-fill>
          </b-col>
          <b-col cols="2">
            <b-input size="sm" v-model="colliFilter" placeholder="Filtrera kolli..."></b-input>
          </b-col>

        </b-row>

      </b-card-header>
      <b-card-body v-if="showCollis" class="collibox">
        <b-row>
          <b-col>
            <table>
              <thead>
                <th></th>
                <th @click="SetColliSortOrder('ColliId')" class="clickable">Kolli Id<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'ColliId'" />
                </th>
                <th @click="SetColliSortOrder('OrderNo')" class="clickable">OrderNr<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'OrderNo'" />
                </th>
                <th @click="SetColliSortOrder('TypeOfColli')" class="clickable">Kollityp<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'TypeOfColli'" />
                </th>
                <th @click="SetColliSortOrder('Description')" class="clickable">Beskrivning<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'Description'" />
                </th>
                <th @click="SetColliSortOrder('Ftx')" class="clickable">Mottagare<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'" v-if="colliSortColumn == 'Ftx'" />
                </th>
                <th @click="SetColliSortOrder('Weight')" class="clickable">Vikt (kg)<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'Weight'" />
                </th>
                <th @click="SetColliSortOrder('Volume')" class="clickable">Volym (m3)<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'Volume'" />
                </th>
                <th @click="SetColliSortOrder('Status')" class="clickable">Status<b-icon
                    :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                    v-if="colliSortColumn == 'Status'" />
                </th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(c, i) in GetCollis(colliFilter, colliSortColumn, colliSortOrder)" :key="i">
                  <td>
                    <b-badge v-if="c.subs && c.subs.length > 0" title="Underkollin" @click="ShowSubCollis(c.ColliId)"
                      class="clickable">
                      <b-icon-box-arrow-in-down></b-icon-box-arrow-in-down>{{ c.subs.length }}
                    </b-badge>
                    <!-- <b-badge v-if="c.parents && c.parents.length > 0"
                      :title="'Ingår i lastbärare '+c.parents[0].LoadCarrierColliId" variant="light"
                      @click="ShowParentColli(c.ColliId)"
                      class="clickable">
                      <b-icon-box-arrow-in-up></b-icon-box-arrow-in-up>
                    </b-badge> -->
                    <b-badge v-if="!c.subs || c.subs.length == 0" title="Visa kollirutt" variant="light"><b-icon-link
                        @click="GetColliRouteWay(c.ColliId)"></b-icon-link></b-badge>
                  </td>
                  <td style="width: 25%">
                    <b-form-input v-model="c.ColliId" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>
                  <td style="width: 125px">
                    <b-form-input v-model="c.OrderNo" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>
                  <td style="width: 75px">
                    <b-form-input v-model="c.TypeOfColli" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>
                  <td style="width: 20%">
                    <b-form-input v-model="c.Description" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>
                  <td style="width: 20%">
                    <b-form-input v-model="c.Ftx" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>
                  <td style="width: 100px">
                    <b-form-input type="number" v-model="c.Weight" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>
                  <td style="width: 150px">
                    <b-form-input type="number" v-model="c.Volume" v-bind:readonly="IsReadonly()"></b-form-input>
                  </td>

                  <td>
                    <b-badge v-if="c.events && c.events.length > 0" title="Händelser"
                      @click="colliToShowEvents = c; colliEventModal = true;" variant="secondary">{{ c.events.length
                      }}<b-icon-clock></b-icon-clock> {{ c.status }}</b-badge>

                  </td>
                  <td>
                    <b-icon-x-circle-fill v-if="!IsReadonly()" v-on:click="RemoveColli(c)"></b-icon-x-circle-fill>
                  </td>
                </tr>
                <tr v-if="!IsChanged()">
                  <td colspan="5"></td>
                  <td align="right"><label>Tot:</label></td>
                  <td class="totcol">
                    <b-form-input type="number" v-model="work.booking.Weight" v-bind:readonly="true"></b-form-input>
                  </td>
                  <td class="totcol"><b-form-input type="number" step="0.001" min="0.00" max="99999.00"
                      v-model="work.booking.Volume" v-bind:readonly="true"></b-form-input></td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="1">
            <b-button size="sm" v-on:click="AddColli()" v-show="!IsReadonly()">Ny rad</b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-header>
        <b-row>
          <b-col>
            Händelser: <span v-if="work.events">({{ work.events.length }}st)</span>
            &nbsp;
            <b-icon-eye-fill @click="showEvents = true" v-if="!showEvents"></b-icon-eye-fill>
            <b-icon-eye-slash-fill @click="showEvents = false" v-if="showEvents"></b-icon-eye-slash-fill>

          </b-col>
          <b-col cols="2">
            <b-input size="sm" v-model="eventFilter" placeholder="Filtrera händelser..."></b-input>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body v-if="showEvents" class="collibox">
        <br />
        <eventlist :events="GetEvents(eventFilter)" :attachments="this.work.attachments"></eventlist>
      </b-card-body>
    </b-card>
    <b-modal ok-only v-model="colliEventModal" size="xl"
      :title="`Händelser för kolli ${colliToShowEvents ? colliToShowEvents.ColliId : ''}`">
      <b-card v-if="colliToShowEvents">
        <eventlist :events="colliToShowEvents.events" :attachments="this.work.attachments"></eventlist>
      </b-card>
    </b-modal>
    <b-modal v-model="colliSelectorVisible" ok-only size="lg">
      <template v-slot:modal-title>
        <b-button-toolbar>
          <h3>{{ colliSelectorColliId }}</h3>
          &nbsp;
          <b-button-group>
            <b-button @click="lcstep(-1)" variant="outline" title="Föregående lastbärare">
              <b-icon-caret-left></b-icon-caret-left>
            </b-button>
            <b-button @click="lcstep(1)" variant="outline" title="Nästa lastbärare">
              <b-icon-caret-right></b-icon-caret-right>
            </b-button>
            <!-- <bookingactionbutton v-if="currId > 0" :ids="[currId]" v-on:actionready="OnActionReady">
              </bookingactionbutton> -->
            <div class="input-group-append" v-if="isBusy">
              <b-icon icon="arrow-clockwise" animation="spin" font-scale="2"></b-icon>
            </div>
            <b-badge size="sm"><b-icon-box-arrow-in-down></b-icon-box-arrow-in-down>{{
    subCollis ? subCollis.length :
      0 }}</b-badge>
          </b-button-group>
        </b-button-toolbar>
      </template>
      <b-card>
        <b-card-header></b-card-header>
        <b-col cols="3">
          <b-input size="sm" ref="subColliFilter" v-model="subColliFilter" placeholder="Sök..."></b-input>
        </b-col>
        <b-card-body>
          <b-icon v-if="!subCollis" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
          <b-table hover small :items="GetFilteredArray(subCollis, subColliFilter)" :fields="subColliFields">
            <template #cell(colliId)="row">
              <b-badge title="Visa kollirutt" variant="light"><b-icon-link
                  @click="GetColliRouteWay(row.item.colliId)"></b-icon-link></b-badge>{{ row.item.colliId }}
            </template>
            <template #cell(tspDocNo)="row">
              <!-- <a href="#" @click="OpenSubBooking(row.item.bookingId)">{{ row.item.tspDocNo }}</a> -->
              <div a v-for="r in row.item.bookings" :key="r.bookingId"><a href="#"
                  @click="OpenSubBooking(r.bookingId)">{{ r.tspDocNo }}</a></div>
            </template>
          </b-table>

        </b-card-body>
      </b-card>
    </b-modal>
    <b-modal v-model="subBookingVisible" title="Fraktdetaljer" ok-only size="xl">
      <bdetails v-if="subBooking" v-bind:booking="subBooking" :readonly="subBooking.booking.Locked"></bdetails>
    </b-modal>
    <b-modal v-model="colliRouteWaysVisible" title="Kollirutt" ok-only size="xl">
      <b-card v-if="colliRouteWays && colliRouteWays.length > 0">
        <b-card-title>
          Kolli: {{ colliRouteWays[0].ColliId }}
        </b-card-title>
        <b-card-body>
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="2"><label>Lastbärare</label></b-col>
            <b-col cols="2"><label>Från</label></b-col>
            <b-col cols="1"></b-col>
            <b-col cols="2"><label>Till</label></b-col>
            <b-col><label>Sändning</label></b-col>
          </b-row>
          <b-row v-for="(c, i) in colliRouteWays" :key="i" class="routerows">
            <b-col cols="1">#{{ i + 1 }}</b-col>
            <b-col cols="2"><b-badge>{{ c.LoadCarrierColliId }}</b-badge><br />
              <clipboardbutton v-if="c.LoadCarrierColliId" :value="c.LoadCarrierColliId"></clipboardbutton>
            </b-col>
            <b-col cols="2">{{ c.PickupPlaceCity }}<br />({{ c.PickupPlaceName }})</b-col>
            <b-col cols="1"><b-icon-arrow-right></b-icon-arrow-right>
              <b-icon-truck></b-icon-truck><b-icon-arrow-right></b-icon-arrow-right></b-col>
            <b-col cols="2">{{ c.DeliveryPlaceCity }}<br />({{ c.DeliveryPlaceName }})</b-col>
            <b-col><a href="#" @click="OpenSubBooking(c.BookingId)">{{ c.TspDocNo }}</a>
              <clipboardbutton v-if="c.TspDocNo" :value="c.TspDocNo"></clipboardbutton><br />
              {{ GetServiceTypeName(c.ServiceTypeId) }}
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-modal>
    <b-modal v-model="placeSelectVisible" ok-only ok-variant="secondary" ok-title="Avbryt">
      <placeselect v-on:placeselected="placeselected"></placeselect>
    </b-modal>
  </div>
</template>
<script>
import Datetimepicker from '@/components/datetimepicker.vue';
import datepicker from "../../components/datepicker";
import lformselect from "@/components/l-form-select.vue"
import clipboardbutton from "./../../components/clipboardbutton.vue";
import eventlist from "./eventlist.vue";
import moment from "moment";
import placeselect from "./placeselect.vue";

import { Api } from "../../lib/api";

const api = new Api();
export default {
  name: "bookingdetails",
  props: {
    booking: Object,
    readonly: Boolean,
  },
  components: {
    datepicker,
    Datetimepicker,
    lformselect,
    clipboardbutton,
    eventlist,
    bdetails: () => import("../booking/bookingdetails.vue"), //https://v2.vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
    placeselect,
  },
  data() {
    return {
      basics: null,
      work: {},
      id: 0,
      origCopy: null,
      showEvents: true,
      showCollis: true,
      colliSelectorVisible: false,
      colliSelectorColliId: null,
      subCollis: [],
      subBooking: null,
      subBookingVisible: false,
      colliFilter: null,
      subColliFilter: null,
      colliSortColumn: null,
      colliSortOrder: 1,
      isBusy: false,
      colliRouteWaysVisible: false,
      colliRouteWays: null,
      subColliFields: [
        { key: 'colliId', label: 'KolliId', sortable: true, sortDirection: 'desc' },
        { key: 'typeOfColli', label: 'Kollityp', sortable: true },
        { key: 'weight', label: 'Vikt', sortable: true, sortDirection: 'desc', formatter: (v) => Math.round(v * 100) / 100 },
        { key: 'tspDocNo', label: 'FsNr', sortable: true, sortDirection: 'desc' },
        { key: 'deliveryPlaceName', label: 'Mottagare', sortable: true, sortDirection: 'desc' },
      ],
      eventFilter: null,
      colliToShowEvents: null,
      colliEventModal: false,
      placeSelectVisible: false,
      placeType: null,
    };
  },
  created() {
    if (!this.origCopy && this.booking != null)
      this.Init();
    //this.origCopy = JSON.stringify(this.booking);
    if (!this.basics) {
      api.get("/api/booking/getbasics").then((res) => {
        this.basics = res.data;
        this.$forceUpdate();
      });
      //this.getData();
    }
  },
  watch: {
    booking: function () {
      this.Init();
    },
  },
  methods: {
    Init() {
      if (this.booking != null) {
        //Calc 
        if (this.booking.colliRoutes && this.booking.collis) {
          this.work = JSON.parse(JSON.stringify(this.booking));
          this.booking.collis.map(c => {
            c.subs = this.booking.colliRoutes.filter(x => x.LoadCarrierColliId == c.ColliId);
            c.parents = this.booking.colliRoutes.filter(x => x.ColliId == c.ColliId);
            // c.subs = this.booking.colliBelongings.filter(x => x.BelongsToColliId == c.ColliId);
            // c.parents = this.booking.colliBelongings.filter(x => x.ColliId == c.ColliId);
            c.events = this.GetEventsForColli(c.ColliId);
            c.status = c.events.length == 0 ? '' : c.events[0].EventTypeName;
          });
        }

        this.work = JSON.parse(JSON.stringify(this.booking));
        this.origCopy = JSON.stringify(this.booking);
        // if(!this.origCopy || this.origCopy.id != this.booking.id)
        //   this.origCopy = JSON.stringify(this.booking);
      }
    },
    IsChanged: function () {
      if (this.readonly) return false;
      if (!this.booking || !this.origCopy) return false;
      const res = !(JSON.stringify(this.work) == this.origCopy);
      return res;
    },
    SetColliSortOrder(sortColumnName) {
      console.log('SetColliSortOrder:' + sortColumnName);
      if (this.colliSortColumn == sortColumnName) {
        this.colliSortOrder = -this.colliSortOrder;
        return;
      }
      this.colliSortColumn = sortColumnName;
    }
    ,
    GetCollis: function (flt, sortColumn, sortOrder) {
      if (this.work.collis) {
        var res = this.work.collis.filter(x => true); //Make array
        if (flt) {
          var f = flt.toUpperCase();
          res = res.filter(c => `${c.ColliId}|${c.OrderNo}|${c.NoOfItems}|${c.TypeOfColli}|${c.Description}|${c.Ftx}|${c.Weight}|${c.Volume}`.toUpperCase().indexOf(f) >= 0);
        }
        if (sortColumn) {
          res = res.sort((a, b) => a[sortColumn] < b[sortColumn] ? sortOrder : -sortOrder);
        }
        return res;
      }

    },
    GetTerminals: function () {
      return (!this.basics) ? [] :
        this.basics.terminals
          .map(x => { return { "value": x.terminalId, "text": x.terminalName } })
          .sort((a, b) => a.text.localeCompare(b.text));
    },
    GetStatus: function (statusId) {
      if (!this.basics || !statusId) return "";
      let s = this.basics.status.find(x => x.StatusId === statusId);
      if (s)
        return s.BookingStatusName;
      return "--";
    },
    GetSubCollis: function (colliId) {
      if (this.work && this.work.colliBelongings) {
        return this.work.colliBelongings.filter(x => x.BelongsToColliId == colliId);
      }
      return [];
    },
    GetParentColli: function (colliId) {
      if (this.work && this.work.colliRoutes) {
        return this.work.colliRoutes.filter(x => x.ColliId == colliId);
      }

      // if (this.work && this.work.colliBelongings) {
      //   return this.work.colliBelongings.filter(x => x.ColliId == colliId);
      // }
      return [];
    },
    GetColliRouteWay(colliid) {
      this.colliRouteWays = null;
      this.colliRouteWaysVisible = false;
      api.get('/api/booking/GetColliRouteWays?colliId=' + colliid).then((res) => {
        this.colliRouteWays = res.data;
        this.colliRouteWaysVisible = true;
      });
    },
    ShowSubCollis: function (colliId) {
      //alert(colliId);
      var params = `bookingId=${this.work.booking.Id}&colliId=${colliId}`;
      this.subCollis = null;
      this.colliSelectorVisible = true;
      this.colliSelectorColliId = colliId;
      this.isBusy = true;
      // api.get("/api/booking/GetSubCollis?" + params).then((res) => {
      //   this.subCollis = res.data;
      //   this.isBusy = false;
      // });
      api.get("/api/booking/GetColliRoutesExt?" + params).then((res) => {
        let subCollis = [];
        res.data.forEach(sc => {
          var c = subCollis.find((x) => x.colliId == sc.colliId);
          if (!c) {
            c = sc;
            c.bookings = [];
            subCollis.push(sc);
          }
          c.bookings.push({ bookingId: sc.bookingId, tspDocNo: sc.tspDocNo });
        });

        //this.subCollis = res.data;
        this.subCollis = subCollis;

        this.isBusy = false;
      });
      setTimeout(() => {
        this.$refs.subColliFilter.focus();
      }, 500);
    },
    ShowParentColli: function (colliId) {
      var pc = this.GetParentColli(colliId);
      if (pc.length > 0) {
        this.subCollis = null;
        this.OpenSubBooking(pc[0].BelongsToBookingId);

        // var params = `bookingId=${pc[0].BelongsToBookingId}&colliId=${pc[0].BelongsToColliId}`;
        // api.get("/api/booking/GetSubCollis?" + params).then((res) => {
        //   var parCollis = res.data.filter(x => x.colliId == colliId);
        //   this.subCollis = parCollis;
        // });
      }
    },
    lcstep: function (stp) {
      var loadCarriers = this.GetCollis(this.colliFilter, this.colliSortColumn, this.colliSortOrder).filter(c => c.subs && c.subs.length > 0);
      var idx = loadCarriers.findIndex(x => x.ColliId == this.colliSelectorColliId) + stp;
      if (idx >= loadCarriers.length) idx = 0;
      if (idx < 0) idx = loadCarriers.length - 1;

      var colliId = loadCarriers[idx].ColliId;
      this.ShowSubCollis(colliId);
    },
    GetServiceTypes: function () {
      return !this.basics ? [] :
        this.basics.serviceTypes.map((x) => { return { "value": x.ServiceTypeId, "text": x.Name } });
    },
    GetProducts: function () {
      return !this.basics ? [] :
        this.basics.products.map((x) => { return { "value": x.ProductKey, "text": `${x.TransporterName}-${x.PrettyName}` } });
    },
    GetServiceTypeName: function (serviceTypeId) {
      if (!this.basics)
        return null;

      var res = this.basics.serviceTypes.find((x) => x.ServiceTypeId == serviceTypeId);
      if (res) return res.Name;
    },
    GetEvents: function () {
      if (!this.work.events)
        return [];
      if (!this.eventFilter)
        return this.work.events;

      let f = this.eventFilter.toLowerCase();
      return this.work.events.filter(x => `${x.Comment}|${x.EventTypeName}|${x.BarCode}`.toLowerCase().indexOf(f) >= 0);


      //.sort((a,b)=> a.RegTime >= b.RegTime);
      //.sort((a, b) => b.RegTime.localeCompare(a.RegTime));
    },
    GetEventsForColli(bc) {
      if (this.work.events) {
        return this.work.events.filter(x => x.BarCode == bc);
      }
    },
    AddColli: function () {
      this.work.collis.push({});
    },
    RemoveColli(c) {
      this.work.collis =
        this.work.collis.filter(function (x) {
          return x !== c;
        });
    },
    CancelChanges: function () {
      //Instead, emit
      this.booking = JSON.parse(this.origCopy);
    },
    IsReadonly: function () {
      return (this.work && this.work.isTotalReadonly) || this.readonly;
    },
    ShowOnMap(name, street, street2, postcode, city) {
      let q = `${street},${street2},${postcode},${city}`;
      window.open(`https://maps.google.se/?q=${q}`);
    },
    Save() {
      //Validation?
      if (confirm("Spara ändringar?")) {
        var p = JSON.parse(JSON.stringify(this.work));
        //p.BookingEvents = [];//Avoid sending this back
        api.post('/api/booking/save', p).then((res) => {
          //this.work.booking = JSON.parse(this.origCopy);
          if (res.data.errMsg) {
            alert(res.data.errMsg);
            return;
          }
          this.$emit('change', res.data.booking.Id);
        });
      }
    },
    formatter(s, k, l, m) {
      return s.length < 20 ? s : s.substring(0, 20);
    },
    OpenSubBooking(bookingid) {
      if (bookingid > 0) {
        this.subBooking = null;
        this.subBookingVisible = false;
        api.get("/api/Booking/GetDetails?id=" + bookingid).then((res) => {
          this.subBooking = res.data;
          this.subBookingVisible = true;
        })

      }
      else
        alert('Kunde inte hitta bokningen.');
    },
    // numberFormat(value,a) {
    //     return value === 0 ? '' : value.toLocaleString();
    //   }
    Validate(inputID) {
      const input = document.getElementById(inputID);
      const validityState = input.validity;

      if (validityState.valueMissing) {
        input.setCustomValidity('You gotta fill this out, yo!');
      } else if (validityState.rangeUnderflow) {
        input.setCustomValidity('We need a higher number!');
      } else if (validityState.rangeOverflow) {
        input.setCustomValidity('Thats too high!');
      } else {
        input.setCustomValidity('');
      }

      input.reportValidity();
    },
    GetFilteredArray(arr, filter) {
      if (!filter)
        return arr;

      let f = filter.toLowerCase();
      return arr.filter(x => `${x.colliId}|${x.tspDocNo}|${x.deliveryPlaceName}|${x.typeOfColli}`.toLowerCase().indexOf(f) >= 0);
    },
    GetPr(w) {
      if (w.pendingRelease.EarliestRelease) {
        var m = moment(w.pendingRelease.EarliestRelease);
        return m.format("YYYY-MM-DD HH:mm");
      }

    },
    selectPlace(type) {
      //type = Pickup, Delivery
      this.placeType = type;
      this.placeSelectVisible = true;
    },
    placeselected(p) {
      let b = this.work.booking;

      if (b) {
        let f = this.placeType;
        b[f + 'PlaceName'] = p.Name;
        b[f + 'PlaceStreet'] = p.Street;
        b[f + 'PlaceStreet2'] = p.Street2;
        b[f + 'PlacePostCode'] = p.PostCode;
        b[f + 'PlaceCity'] = p.City;
        b[f + 'Phone'] = p.ContactPhone;
        b[f + 'Email'] = p.ContactEmail;

        this.placeSelectVisible = false;
      }
    },
  }
}

</script>


<style>
.form-control {
  height: auto;
}

.routerows {
  border: darkblue;
  border-bottom-style: dotted;
}

.collibox {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.totcol {
  border: 2px solid darkgray;
}
</style>